import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { TablesDisplayGridRowDataFragmentGql } from './TablesDisplayGridRowDataFragmentGql';

export const UpstreamVirtualConnectionTablesFilteredByFieldQueryGql: DocumentNode = gql`
query UpstreamVirtualConnectionTablesFilteredByFieldQuery(
  $selectedFieldId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: VirtualConnectionTableSortOrder!,
  $publishedConnectionsLineageEnabled: Boolean!
) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamVirtualConnectionTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...TablesDisplayGridRowDataFragment
        }
      }
      maxDownstreamDatasources: upstreamTablesConnection(
        orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection { totalCount }
        }
      }
      maxDownstreamWorkbooks: upstreamTablesConnection(
        orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection { totalCount }
        }
      }
    }
  }
}
${TablesDisplayGridRowDataFragmentGql}
`;
